<template>
  <div class="stockApp">
    <div class="stock">
      <Header @getLoginInfo="getLoginInfoFn"></Header>
      <main>
        <div class="mainTop">
          <div class="underHeader">
            <img src="../../assets/img/info.png" alt />
            当前位置：
          </div>
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:'/searchPage'}">企业搜索</el-breadcrumb-item>
            <el-breadcrumb-item>{{businessLabel.company_name}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="mainBox">
          <div class="mainBottom">
            <div class="marinBottom_top">
              <div class="topBox_1">
                <div class="businessLabelBox">
                  <div class="img">
                    <img src="../../assets/img/gs.png" style="width:50px;height:49px;" alt />
                  </div>
                  <div class="column">
                    <div class="names">
                      <h3>{{businessLabel.company_name}}</h3>
                      <p v-if="businessLabel.management_forms">{{businessLabel.management_forms}}</p>
                    </div>
                    <div class="tags">
                      <p v-if="businessLabel.region">{{businessLabel.region}}</p>
                      <p
                        v-if="businessLabel.industry"
                        :title="industryTitle"
                      >{{businessLabel.industry}}</p>
                      <p v-for="(v,i) in specialLabel" :key="i" v-if="v.showName!=''">{{v.showName}}</p>
                    </div>
                    <div class="tags" v-for="(s,k) in specialLabel2" :key="k" v-if="showTags">
                      <p v-for="(v,i) in s" :key="i" v-if="v.showName!=''">{{v.showName}}</p>
                    </div>
                  </div>
                  <div class="ckgd" v-if="specialLabel2.length>0">
                    <span></span>
                    <span @click="ckgd">
                      查看更多
                      <img src="../../assets/img/top.png" v-if="showTags" alt />
                      <img src="../../assets/img/bottom.png" v-else alt />
                    </span>
                  </div>
                </div>
                <div class="buttonBox">
                  <!-- <p>最后更新时间：{{timer}}</p> -->
                  <button v-if="btnInd==0" @click="addStoreup">
                    关注
                    <img src="../../assets/img/sc.png" alt />
                  </button>
                  <button v-if="btnInd==1">
                    已关注
                    <img src="../../assets/img/sc2.png" alt />
                  </button>
                </div>
              </div>
              <!-- <div class="topBox_2">
                <div class="topBox_2_left">
                  <p
                    class="p1"
                    v-for="(v,i) in specialLabel"
                    :key="i"
                    v-if="v.showName!=''"
                  >{{v.showName}}</p>
                </div>
                <div class="topBox_2_right">
                  <jqueryWord></jqueryWord>
                </div>
              </div>-->
            </div>
            <div class="marinBottom_bottom">
              <div class="marinBottom_b_left">
                <div class="b_left_nav">
                  <div class="left_nav_box">
                    <div
                      v-if="v.show==0"
                      class="left_nav"
                      :class="left_nav_box_ind==i?'left_nav_active':''"
                      v-for="(v,i) in left_nav_box"
                      :key="i"
                      @click="changeLeftInd(i,v.parentCode)"
                    >{{v.name}}</div>
                  </div>
                  <div class="showLeftNav">
                    <div
                      v-for="(v,i) in businessTitle"
                      :key="i"
                      @click="aScroll(v.title_code,v.haveData)"
                      :style="v.haveData?'cursor: pointer;':'cursor: not-allowed'"
                    >
                      <p class="cir"></p>
                      {{v.title_name}}
                    </div>
                  </div>
                </div>
                <div class="b_left_list">
                  <div v-for="(v,i) in  bqData" :key="i" :id="i" class="b_left_list_box">
                    <div class="list_top">
                      <span>{{v.titleName?v.titleName:''}}</span>
                      <div>
                        <span v-if="v.titleName=='年报公示'">选择年限</span>
                        <el-select
                          v-model="value"
                          placeholder="请选择"
                          v-if="v.titleName=='年报公示'"
                          @change="changeNx(v.titleList)"
                        >
                          <el-option
                            v-for="(item,k) in v.titleList"
                            :key="k"
                            :label="item"
                            :value="k"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="rightPaging" v-if="v.total">
                        <el-pagination
                          prev-text="上一页"
                          next-text="下一页"
                          background
                          @current-change="(...defaultArgs) => handleCurrentChange(i, ...defaultArgs)"
                          :page-size="10"
                          layout="total, prev, pager, next, jumper"
                          :total="v.total"
                        ></el-pagination>
                      </div>
                    </div>
                    <div v-if="v.titleName=='年报公示'">
                      <div v-for="(s,k) in v" :key="k" class="b_left_list_box">
                        <div class="list_top" v-if="s.titleName">
                          <span>{{s.titleName?s.titleName:''}}</span>
                        </div>
                        <TableTwo
                          v-if="s.showType==1"
                          :titles="s.titles"
                          :rows="s.rows"
                          :tableStyle="{ width:'100%' }"
                        ></TableTwo>

                        <Table v-if="s.showType==2" :titles="s.titles" :rows="s.rows"></Table>
                        <TableThree v-if="s.showType==3" :rows="s.rows"></TableThree>
                        <TableFour
                          v-if="s.showType==4"
                          :data1="s.data1"
                          :data2="s.data2"
                          :titleName="s.titleName"
                        ></TableFour>
                      </div>
                    </div>
                    <TableTwo
                      v-if="v.showType==1"
                      :titles="v.titles"
                      :rows="v.rows"
                      :tableStyle="{ width:'100%' }"
                    ></TableTwo>

                    <Table v-if="v.showType==2" :titles="v.titles" :rows="v.rows"></Table>
                    <TableThree v-if="v.showType==3" :rows="v.rows"></TableThree>
                    <TableFour
                      v-if="v.showType==4"
                      :data1="v.data1"
                      :data2="v.data2"
                      :titleName="v.titleName"
                    ></TableFour>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="marinBottom_right">
            <div class="company_right">
              <div v-for="(item,key) in company_right_data" :key="key" class="companyBox">
                <h3 @click="goEnterprisesDetail(item)">{{item.companyName}}</h3>
                <!-- <div class="btnBoxs">
                  <button class="bt1">国企</button>
                  <button class="bt2">上市企业</button>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import LeftNav from "@/components/leftNav";
import api from "@/../static/common/api/api.js";
import jqueryWord from "@/components/jquery_word";
import Table from "@/components/table.vue";
import TableTwo from "@/components/table2.vue";
import TableThree from "@/components/table3.vue";
import TableFour from "@/components/table4.vue";
import magic from "@/../static/common/magic.js";

export default {
  props: {},
  components: {
    Header,
    Footer,
    LeftNav,
    jqueryWord,
    Table,
    TableTwo,
    TableThree,
    TableFour
  },
  data() {
    return {
      collapse: true, //隐藏导航
      activeIndex: null,
      value: 0, //年报切换 value
      timer: "", //更新时间
      businessTitle: [],
      businessLabel: [],
      specialLabel: [],
      specialLabel2: [],
      showTags: false,
      titleData: [],
      parentCode: "baseinfo",
      btnInd: 0, //收藏按钮切换
      entId: "",
      left_nav_box: [
        {
          name: "基本信息",
          parentCode: "baseinfo",
          show: 0
        },
        {
          name: "海关企业",
          parentCode: "customs",
          show: 0
        },
        {
          name: "医药企业",
          parentCode: "medicine",
          show: 0
        },
        {
          name: "工业企业",
          parentCode: "industry",
          show: 0
        },
        {
          name: "上市企业",
          parentCode: "list",
          show: 0
        },
        {
          name: "经营发展",
          parentCode: "business_development",
          show: 0
        },
        // {
        //   name: "经营风险",
        //   parentCode: "business_risk",
        //   show: 0
        // },
        {
          name: "法律风险",
          parentCode: "legal_risk",
          show: 0
        },
        {
          name: "企业图谱",
          parentCode: "enterprise_map",
          show: 0
        }
        // {
        //   name: "同业分析",
        //   show: 0
        // }
      ], //默认导航
      left_nav_box_ind: 0, //默认导航下标
      bqData: [], // 标签数据
      company_right_data: [], //推荐数据
      industryTitle: "",
      userId: "" // 用户id
    };
  },
  watch: {
    "$route.query.entId"(to, from) {
      //监听路由是否变化
      if (this.$route.path == "/enterprisesDetail") {
        //仅在当前页面生效
        if (to != from) {
          // location.replace(location.href);
          this.specialLabel= [];
          this.specialLabel2=[];
          this.showTags = false;
          this.entId = this.$route.query.entId;
          this.timer = magic.getTimer();
          this.$nextTick(function() {
            window.addEventListener("scroll", this.onScroll);
          });
          this.getBusinessFirstShowData(this.parentCode);
          this.getBusinessLabel();
          this.getBusinessTitle(this.parentCode);
          this.isStoreup();
          this.getRecommendCompany();
        }
      }
    }
  },
  computed: {},
  methods: {
    getLoginInfoFn(val) {
      //获取用户信息
      this.userId = val.userId;
    },
    // 导航切换
    changeLeftInd(i, parentCode) {
      if (parentCode == "enterprise_map") {
        //企业图谱特殊处理
        this.$router.push({
          path: "/atlas",
          query: {
            companyName: this.businessLabel.company_name,
            entId: this.entId
          }
        });
      } else {
        this.titleData = [];
        this.left_nav_box_ind = i;
        this.parentCode = parentCode;
        this.getBusinessTitle(parentCode);
        this.getBusinessFirstShowData(parentCode);
      }
      // setTimeout(() => {
      //   this.titleData.forEach((v, i) => {
      //     let params = {
      //       // entId: this.entId,
      //       entId: this.entId,
      //       parentCode: this.parentCode,
      //       childCode: v
      //     };
      //     // document.getElementById(id).scrollIntoView(); //锚点
      //     api.getBusinessLabelShowData(params).then(res => {
      //       this.bqData[v] = res.data[v];
      //       this.$forceUpdate();
      //       // console.log(this.bqData, "parg");
      //     });
      //   });
      // }, 2000);
    },
    //年报公示切换时间事件
    changeNx(data) {
      this.getBusinessLabelShowData(
        this.parentCode,
        "annual_reports",
        null,
        data[this.value]
      );
    },
    //锚点
    aScroll(childCode, haveData) {
      if (haveData) {
        if (childCode) {
          $("html, body").animate(
            {
              scrollTop: $("#" + childCode).offset().top
            },
            400
          );
        }
      }
    },
    // 第一次点击获取前5个标签数据
    getBusinessFirstShowData(parentCode) {
      let params = {
        entId: this.entId,
        parentCode: parentCode
      };
      api.getBusinessFirstShowData(params).then(res => {
        this.bqData = res.data;
      });
    },
    // 获取标签
    getBusinessLabel() {
      let params = {
        entId: this.entId
      };
      api.getBusinessLabel(params).then(res => {
        this.businessLabel = res.data.baseLabel;
        if (this.businessLabel.industry) {
          var arr = this.businessLabel.industry;
          var arr2 = this.businessLabel.industry.split("|");
          this.industryTitle = arr2[0] + " | " + arr2[1] + " | " + arr2[2];
          this.businessLabel.industry = arr.split("|")[2];
        }
        this.specialLabel = res.data.specialLabel.splice(0, 4);
        for (var i = 0, len = res.data.specialLabel.length; i < len; i += 6) {
          this.specialLabel2.push(res.data.specialLabel.slice(i, i + 6));
        }
        let { customs, industry, list, medicine } = res.data;
        this.left_nav_box.forEach((v, i) => {
          if (v.parentCode == "customs") {
            v.show = customs;
          } else if (v.parentCode == "industry") {
            v.show = industry;
          } else if (v.parentCode == "list") {
            v.show = list;
          } else if (v.parentCode == "medicine") {
            v.show = medicine;
          }
        });
        // console.log(res.data, "获取标签");
      });
    },
    //推荐企业
    getRecommendCompany() {
      let params = {
        entId: this.entId
      };
      api.getRecommendCompany(params).then(res => {
        this.company_right_data = res.data;
      });
    },
    //跳转推荐企业
    goEnterprisesDetail(v) {
      // console.log(v);
      this.$router.push({
        path: "/enterprisesDetail",
        query: { entId: v.entId }
      });
    },
    //获取指定标签数据
    getBusinessLabelShowData(parentCode, childCode, pageNo, reportDate) {
      let _this = this;
      let params = {
        entId: _this.$route.query.entId,
        // entId: this.entId,
        parentCode,
        childCode,
        pageNo,
        reportDate
      };
      api.getBusinessLabelShowData(params).then(res => {
        _this.bqData[childCode] = res.data[childCode];
        _this.$forceUpdate();
      });
    },
    //获取title
    getBusinessTitle(parentCode) {
      let params = {
        entId: this.entId,
        parentCode: parentCode
      };
      api.getBusinessTitle(params).then(res => {
        this.businessTitle = res.data;
        this.businessTitle.forEach((v, i) => {
          this.titleData.push(v.title_code);
        });
        this.titleData.splice(0, 5);
      });
    },
    //下一页
    handleCurrentChange(childCode, pageNo) {
      this.getBusinessLabelShowData(this.parentCode, childCode, pageNo);
    },
    // 获取滚动条当前的位置
    getScrollTop() {
      var scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    // 获取当前可视范围的高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },
    //查看更多
    ckgd() {
      this.showTags = !this.showTags;
    },
    // 获取文档完整的高度
    getScrollHeight() {
      return Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
    },
    // 滚动事件触发下拉加载
    onScroll() {
      if (
        this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <=
        0
      ) {
        var arr = this.titleData.splice(0, 3);
        if (arr.length > 0) {
          arr.forEach((v, i) => {
            let params = {
              entId: this.entId,
              parentCode: this.parentCode,
              childCode: v
            };
            api.getBusinessLabelShowData(params).then(res => {
              if (JSON.stringify(res.data) != "{}") {
                this.bqData[v] = res.data[v];
              }
              this.$forceUpdate();
            });
          });
        }
      }
    },
    addStoreup() {
      //关注
      try {
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(2);
      } catch (e) {}
      let params = {
        userId: this.userId,
        entId: this.entId
      };
      api.addStoreup(params).then(res => {
        if (res.message) {
          this.btnInd = 1;
        }
        this.$message({
          message: res.data,
          type: res.message
        });
      });
    },
    isStoreup() {
      //判断是否关注
      let params = {
        entId: this.entId
      };
      api.isStoreup(params).then(res => {
        if (res.data.collectFlag) {
          this.btnInd = 1;
        } else {
          this.btnInd = 0;
        }
      });
    }
  },

  mounted() {
    magic.loginOrRights(1).then(res => {
      if (!res) {
        this.$router.push("/login");
      }
    });
    this.entId = this.$route.query.entId;
    this.timer = magic.getTimer();
    this.$nextTick(function() {
      window.addEventListener("scroll", this.onScroll);
    });
    this.getBusinessFirstShowData(this.parentCode);
    this.getBusinessLabel();
    this.getBusinessTitle(this.parentCode);
    this.isStoreup();
    this.getRecommendCompany();
    $(".tssjHover").hover(
      m => {},
      s => {
        this.tssjShow = false;
        this.tssjShow_1 = false;
      }
    );
    $(".tssj1").hover(
      m => {
        this.tssjShow = true;
      },
      s => {
        this.tssjShow = false;
      }
    );
    $(".tssj2").hover(
      m => {
        this.tssjShow_1 = true;
      },
      s => {
        this.tssjShow_1 = false;
      }
    );
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";

.stockApp {
  display: flex;
  background: url("../../assets/img/bg.png") no-repeat top;
  background-size: 100% 100%;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  box-sizing: border-box;
  .mainTop {
    display: flex;
    .underHeader {
      display: inline-block;
      height: 54px;
      line-height: 54px;
      padding-left: 19px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
      img {
        width: 12px;
        height: 16px;
      }
    }
    /deep/ .el-breadcrumb__inner {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
    /deep/ .el-breadcrumb__inner:hover {
      color: #dfecf7;
    }
  }
  .mainBox {
    display: flex;
  }
  .mainBottom {
    width: 80%;
    flex: 1;
    display: flex;
    flex-direction: column;
    .marinBottom_top {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      background: rgba(5, 43, 79, 0.3);
      border: 1px solid #08396a;
      padding: 0 20px;
      box-sizing: border-box;
      .topBox_1 {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #08396a;
        .businessLabelBox {
          display: flex;
          flex: 1;
          height: 100%;
          h3 {
            margin-right: 10px;
            margin-left: 9px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #f1f8ff;
          }
          .column {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding: 20px 0;
            box-sizing: border-box;
          }
          .names {
            display: flex;
            align-items: center;
          }
          .tags {
            display: flex;
            align-items: center;
            margin-top: 5px;
          }
          .img {
            display: flex;
            align-items: center;
            height: 100px;
          }
          p {
            width: auto;
            height: 20px;
            line-height: 20px;
            padding: 0 20px;
            margin-left: 10px;
            background: rgba(60, 152, 245, 0.2);
            border-radius: 2px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #3c98f5;
          }

          p:nth-child(odd) {
            // background: rgba(255, 145, 107, 0.2);
            background: rgba(0, 153, 68, 0.2);
            // color: #ff916b;
            color: #009944;
          }
          .ckgd {
            height: 100px;
            margin-left: 20px;
            display: flex;
            align-items: center;
            color: #128bed;
            flex-direction: column;
            justify-content: space-around;
            img {
              vertical-align: middle;
              height: 12px;
            }
          }
        }
        .buttonBox {
          display: flex;
          align-items: center;
          button {
            width: 90px;
            height: 32px;
            background: #177fe8;
            border-radius: 2px;
            margin-left: 21px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #dfecf7;
            border: 0;
            img {
              width: 10px;
              height: 10px;
            }
          }
          p {
          }
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #bac7d5;
        }
      }
      .topBox_2 {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .topBox_2_left {
          height: 180px;
          width: 50%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-right: 144px;
          .p1 {
            width: 23%;
            height: 36px;
            background: rgba(42, 220, 247, 0.2);
            border-radius: 2px;
            color: #2adcf7;
            text-align: center;
            line-height: 36px;
            margin: 0 7px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
          }
          .p2 {
            width: 165px;
            height: 36px;
            background: rgba(247, 172, 42, 0.2);
            border-radius: 2px;
            color: #f7ac2a;
            text-align: center;
            line-height: 36px;
            margin: 0 7px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
          }
          .p3 {
            width: 165px;
            height: 36px;
            background: rgba(247, 66, 42, 0.2);
            border-radius: 2px;
            color: #f7422a;
            text-align: center;
            line-height: 36px;
            margin: 0 7px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
          }
        }
        .topBox_2_right {
          margin-right: 44px;
          width: 471px;
          height: 262px;
        }
      }
    }
    .marinBottom_bottom {
      width: 100%;
      display: flex;
      margin-top: 20px;
      justify-content: space-around;
      background: rgba(5, 43, 79, 0.8);
      border: 1px solid #08396a;
      .marinBottom_b_left {
        width: 100%;
        height: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
        .b_left_nav {
          display: flex;
          height: auto;
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;
          align-items: center;

          flex-direction: column;
          .left_nav_box {
            width: 100%;
            display: flex;
            align-items: center;
            height: 40px;
            border-bottom: 1px solid #08396a;
            .left_nav {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #6d84a2;
              margin-right: 50px;
              height: 40px;
              line-height: 40px;
              cursor: pointer;
            }
            .left_nav_active {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #dfecf7;
              border-bottom: 1px solid #368ce4;
            }
          }

          .showLeftNav {
            width: 100%;
            display: flex;
            height: auto;
            flex-wrap: wrap;
            .cir {
              width: 2px;
              height: 2px;
              background: #bac7d5;
              border-radius: 1px;
              margin-right: 5px;
            }
            div {
              width: auto;
              display: flex;
              align-items: center;
              width: auto;
              height: 40px;
              line-height: 40px;
              box-sizing: border-box;
              text-align: center;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              margin-right: 50px;
              color: #dfecf7;
            }
          }
        }
        .b_left_list {
          margin-top: 20px;
          margin-bottom: 20px;
          width: 100%;
          flex: 1;
          padding: 0 20px;
          box-sizing: border-box;
          .b_left_list_box {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #dfecf7;
            width: 100%;
            margin-top: 20px;
            .list_top {
              height: 40px;
              display: flex;
              justify-content: space-between;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
  .marinBottom_right {
    width: 240px;
    background: rgba(5, 43, 79, 0.3);
    border-radius: 0px 0px 0px 2px;
    border: 1px solid #08396a;
    margin-left: 20px;
    .company_right {
      background-color: rgba(5, 43, 79, 0.3);
      border-radius: 0px 0px 0px 2px;
      padding: 0 21px;
      box-sizing: border-box;
      .companyBox {
        margin-top: 36px;
        padding-bottom: 27px;
        border-bottom: 1px solid #023261;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: start;
        h3 {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #bac7d5;
          cursor: pointer;
        }
        .btnBoxs {
          margin-top: 14px;
          button {
            padding: 3px 5px;
            box-sizing: border-box;
            border: 0;
          }
          .bt1 {
            background: #3c98f5;
            border-radius: 2px;
            background-color: rgba(60, 152, 245, 0.2);
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #3c98f5;
          }
          .bt2 {
            background-color: rgba(247, 172, 42, 0.2);
            border-radius: 2px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #f7ac2a;
          }
        }
      }
    }
  }
}
/deep/ .el-menu {
  background: transparent;
}
/deep/ .el-menu.el-menu--horizontal {
  border: 0;
}
/deep/ .el-pagination__total,
/deep/ .el-pagination__jump {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #bac7d5;
}
</style>
 


// WEBPACK FOOTER //
// src/view/enterprises/enterprisesDetail.vue